// export const environment = {
//   production: true,
//   baseUrl: `${window.location.origin}/api`,
//   redirectUrl: 'https://dev-entregis.set.or.th/login/admin',
//   tenant: '7cf70668-de90-4e0a-bdc1-42dd27fc4aee',
//   clientId: '405c9650-3733-416f-8699-af0bdae4edcd',
//   setLink: 'https://test.setlink.set.or.th/ '
// };

export const environment = {
  production: true,
  baseUrl: `${window.location.origin}/api`,
  redirectUrl: 'https://dev-corporate-access.setstage.or.th/login/admin',
  tenant: '7cf70668-de90-4e0a-bdc1-42dd27fc4aee',
  clientId: '405c9650-3733-416f-8699-af0bdae4edcd',
  setLink: 'https://test.setlink.set.or.th/ '
};
